import React from 'react';
import { JournalHeader } from '../components/JournalHeader';
import { ArticleHeader } from '../components/ArticleHeader';
import { ArticleSummary } from '../components/ArticleSummary';
import { TableOfContents } from '../components/TableOfContents';
import { ArticleBody } from '../components/ArticleBody';
import { ArticleFooter } from '../components/ArticleFooter';
import { RulesSection } from '../components/RulesSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { ConclusionSection } from '../components/ConclusionSection';
export function ArticlePage() {
  return <div className="min-h-screen bg-white text-[#1B1B2F]" data-id="element-322">
      <JournalHeader data-id="element-323" />
      <main className="max-w-3xl mx-auto px-4 pb-12" data-id="element-324">
        <ArticleHeader data-id="element-325" />
        <ArticleSummary data-id="element-326" />
        <TableOfContents data-id="element-327" />
        <ArticleBody data-id="element-328" />
        <RulesSection data-id="element-329" />
        <ComparisonSection data-id="element-330" />
        <ConclusionSection data-id="element-331" />
      </main>
      <ArticleFooter data-id="element-332" />
    </div>;
}